import React from "react";
import "../../../styles/maintenanceWorkspace.css";

export default function OfficeMaintenanceRequestsPanel({
  activeTab,
  onTabChange,
  directorySlot,
  trackerSlot,
}) {
  return (
    <div
      id="mr-workspace"
      className="user-builder-panel mr-requests-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="mr-requests-panel__masthead">
        <div className="mr-requests-panel__titles">
          <h3 className="user-builder-panel__title">Requests</h3>
          <p className="user-builder-panel__hint">
            Search and export in the <strong>Directory</strong> tab. In <strong>Status tracker</strong>,
            filter by status with the pills, then review dates and attachments.{" "}
            <strong>Assigned to</strong> is the person doing the work, not the reporter. Bulk status
            updates are done in the admin maintenance area.
          </p>
        </div>
        <nav className="mr-requests-panel__tabs" role="tablist" aria-label="Request views">
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "directory"}
            id="mr-tab-directory"
            aria-controls="mr-panel-directory"
            className={`mr-requests-panel__tab${activeTab === "directory" ? " mr-requests-panel__tab--active" : ""}`}
            onClick={() => onTabChange("directory")}
          >
            Directory
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "tracker"}
            id="mr-tab-tracker"
            aria-controls="mr-panel-tracker"
            className={`mr-requests-panel__tab${activeTab === "tracker" ? " mr-requests-panel__tab--active" : ""}`}
            onClick={() => onTabChange("tracker")}
          >
            Status tracker
          </button>
        </nav>
      </div>

      <div
        id="mr-panel-directory"
        role="tabpanel"
        aria-labelledby="mr-tab-directory"
        hidden={activeTab !== "directory"}
        className="mr-requests-panel__pane"
      >
        {directorySlot}
      </div>
      <div
        id="mr-panel-tracker"
        role="tabpanel"
        aria-labelledby="mr-tab-tracker"
        hidden={activeTab !== "tracker"}
        className="mr-requests-panel__pane"
      >
        {trackerSlot}
      </div>
    </div>
  );
}
